import theme from '@styles/theme';
const hoverElement = (active = true, color: string | null = null) => ({
  content: '""',
  position: 'absolute',
  width: '100%',
  opacity: active ? 1 : 0,
  left: 0,
  bottom: '-4px',
  height: '1px',
  background: color || theme.rawColors.darkGrey700
});
export default {
  marketingTopContentContainer: {
    pb: 20
  },
  marketingTopContent: (color: string | null = null) => ({
    display: 'flex',
    alignItems: 'flex-start',
    pb: 20,
    span: {
      cursor: 'pointer',
      position: 'relative',
      fontFamily: theme.fonts.uniformMedium,
      fontWeight: theme.fontWeights.medium,
      fontSize: theme.fontSizes.text,
      letterSpacing: theme.letterSpacings.bigCaps,
      '&:hover': {
        '&:before': hoverElement(true, color)
      }
    }
  }),
  marketingButtonContent: (color: string | null = null) => ({
    color: color || theme.rawColors.darkGrey700,
    fontFamily: theme.fonts.uniform,
    fontSize: theme.fontSizes.text,
    fontWeight: theme.fontWeights.normal,
    fontStyle: 'normal',
    letterSpacing: theme.letterSpacings.bigCaps,
    lineHeight: '140%'
  })
};